import React, { useContext, useEffect, useState } from 'react';
import './Sidebar.css';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useHistory, withRouter, useLocation } from 'react-router';

import { SidebarData } from './SidebarData';
import { FirebaseContext } from '../../../context/firebase';
import CleanTechFull from '../../../images/cleantech-full.png';
import companyLogoFull from '../../../images/companyLogoFull.png';
import DuoIcon from '@material-ui/icons/Duo';
import HomeIcon from '@material-ui/icons/Home';
import SpeedIcon from '@material-ui/icons/Speed';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import defaultUser from '../../../assets/defaultUser.png';
import { CircularProgress } from '@material-ui/core';

function Sidebar() {
	const { firebase } = useContext(FirebaseContext);

	const [userType, setUserType] = useState('');
	const [loading, setLoading] = useState(false);
	const history = useHistory();
	const location = useLocation();

	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	useEffect(() => {
		firebase.auth().onAuthStateChanged(async (user) => {
			if (user) {
				var currentUserId = firebase.auth().currentUser.uid;
				var currentUserType;
				var capFirst;

				console.log('Current user Id; ' + currentUserId);
				await firebase
					.database()
					.ref('/users/' + currentUserId + '/userType')
					.once('value', function (snapshot) {
						currentUserType = snapshot.val();
						console.log('THIS IS USER TYPE: ' + currentUserType);
					});
				setUserType(currentUserType);
			}
		});
	}, [userType]);

	const handleVideoCall = async () => {
		setLoading(true);
		var createNewAppointment = await firebase
			.functions()
			.httpsCallable('CreateMeetingFromData');

		//firebase.auth().onAuthStateChanged(function (user) {
		var currentUserId = firebase.auth().currentUser.uid;
		var currentUserEmail = firebase.auth().currentUser.email;
		var currentUserType;
		var currentUserPhoneNumber;
		var currentUserName;

		await firebase
			.database()
			.ref('users/' + currentUserId)
			.once('value', (snapshot) => {
				currentUserType = snapshot.val()?.userType;
				currentUserPhoneNumber = snapshot.val()?.phoneNumber;
				currentUserName = snapshot.val().displayName;
			});

		console.log(
			'currentUserType: ' +
				currentUserType +
				' currentUserName: ' +
				currentUserName +
				' currentUserPhoneNumber: ' +
				currentUserPhoneNumber
		);

		var dateObj = new Date().getTime();

		//here we need to push to that cloud function

		var detailsForCall = {
			thisEmail: currentUserEmail,
			thisName: currentUserName,
			thisAppointmentCode: 'meeting',
			thisAppointmentTime: dateObj,
			thisUserType: currentUserType,
			thisPhone: currentUserPhoneNumber,
			thisUID: currentUserId,
		};

		var appointmentPost = {
			appointmentID: 'none',
			appointmentName: 'Adhoc_Appointment_Made_by_Admin_',
			timeOfAppointment: dateObj,
			assignedTo: 'Adhoc',
			started: false,
			createrID: currentUserId,
			sentRemind: false,
			createUser: false,
		};

		var shortLongCode;

		var users = {
			'0': {
				email: 'null',
				fullName: 'null',
				phoneNumber: 'null',
			},
		};

		appointmentPost['users'] = users;

		await createNewAppointment(appointmentPost)
			.then((result) => {
				console.log('results: ' + result.data.longCode);
				shortLongCode = result.data;
				setLoading(false);
			})
			.catch(function (error) {
				console.log('Error ' + error);
			});

		detailsForCall['shortCode'] = shortLongCode.shortCode;
		detailsForCall['thisAppointmentCode'] = shortLongCode.longCode;

		console.log('Long code Side bar ' + detailsForCall['longCode']);
		console.log('short code Side bar ' + detailsForCall['shortCode']);

		console.log('Current user details: ' + JSON.stringify(detailsForCall));

		history.push({
			pathname: '/videocall',
			state: {
				detail: detailsForCall,
			},
		});
	};

	const styleDisableBtn = (link) => {
		if (history.location.pathname === link) {
			return { pointerEvents: 'none' };
		}
	};
	return (
		<>
			{loading && (
				<div className='loading_layout_videocall'>
					<div className='inner_loading_layout'>
						<CircularProgress className='circular-load' />
						<div className='authenticate-text'>
							<p>Authenticating...</p>
						</div>
					</div>
				</div>
			)}
			<div className='sidebar' id='sidebar'>
				<div className='comp-logo'>
					<img
						src={companyLogoFull}
						alt='Company Logo'
						className='comp-logo-img'
						onClick={() => {
							window.location = 'https://cleantechcommons.ca/';
						}}
					/>
				</div>
				<div
					className='profile-badge'
					// onClick={() =>
					// 	history.push(`/profile/${firebase.auth().currentUser.uid}`)
					// }
				>
					<img src={defaultUser} alt='Profile Picture' />
					<div className='username'>
						{firebase.auth().currentUser?.displayName
							? firebase.auth().currentUser?.displayName
							: firebase.auth().currentUser?.email}
					</div>
					<div className='user-type'>{userType}</div>
				</div>
				<ul className='sidebar-list'>
					<div className='sidebar-seperator-title'>
						<h3>NAVIGATIONS</h3>
					</div>
					<li
						className='sidebar-row'
						id={window.location.pathname == '/' ? 'active' : ''}
						style={{ ...styleDisableBtn('/') }}
						onClick={() => {
							history.push('/');
						}}
					>
						<div id='sidebar-icon'>
							<SpeedIcon />
						</div>
						<div id='sidebar-title'>Dashboard</div>
						<div className='sidebar-carret'>
							<KeyboardArrowRightIcon />
						</div>
					</li>
					{(userType === 'admin' || userType === 'superadmin') && (
						<>
							<hr />
							<div className='sidebar-seperator-title'>
								<h3>FEATURES</h3>
							</div>
							<li
								className='sidebar-row videocall-btn'
								id={location.pathname == '/videocall' ? 'active' : ''}
								style={{ ...styleDisableBtn('/videocall') }}
								onClick={() => {
									handleVideoCall();
								}}
							>
								<div id='sidebar-icon'>
									<DuoIcon />
								</div>
								<div id='sidebar-title'>Video Call</div>
								<div className='sidebar-carret'>
									<KeyboardArrowRightIcon />
								</div>
							</li>
						</>
					)}

					{SidebarData.map((val, key) => {
						// console.log('SIDE BAR DATA USERTYPE ' + userType);
						if (val.role.includes(userType)) {
							return (
								<li
									key={key}
									className='sidebar-row'
									id={location.pathname == val.link ? 'active' : ''}
									style={{ ...styleDisableBtn(val.link) }}
									onClick={() => {
										history.push({ pathname: val.link });
									}}
								>
									<div id='sidebar-icon'>{val.icon}</div>
									<div id='sidebar-title'>{val.title}</div>
									<div className='sidebar-carret'>
										<KeyboardArrowRightIcon />
									</div>
								</li>
							);
						} else if (val.canBeNull === true && userType === null) {
							return (
								<li
									key={key}
									className='sidebar-row'
									id={location.pathname == val.link ? 'active' : ''}
									onClick={() => {
										location.pathname = val.link;
										// history.push({ pathname: val.link });
									}}
								>
									<div id='sidebar-icon'>{val.icon}</div>
									<div id='sidebar-title'>{val.title}</div>
									<div className='sidebar-carret'>
										<KeyboardArrowRightIcon />
									</div>
								</li>
							);
						}
					})}

					<hr />
					<div className='sidebar-seperator-title'>
						<h3>EXTRAS</h3>
					</div>
					<li
						className='sidebar-row signout-btn'
						onClick={() => {
							firebase.auth().signOut();
							// window.location.pathname = '/signin';
						}}
					>
						<div id='sidebar-icon'>
							<ExitToAppIcon />
						</div>
						<div id='sidebar-title'>Sign Out</div>
						<div className='sidebar-carret'>
							<KeyboardArrowRightIcon />
						</div>
					</li>
				</ul>
			</div>
			<div className='top-bar' id='topbar'>
				<div className='small-profile-badge'>
					<div className='dropdown-btn-profile'>
						<div className='d-flex'>
							<img src={defaultUser} alt='Profile Picture' />
							<div className='username'>
								{firebase.auth().currentUser.displayName
									? firebase.auth().currentUser.displayName
									: firebase.auth().currentUser.email}
							</div>
						</div>
						<div className='top-dropdown-content'>
							{/* <a
								onClick={() =>
									history.push(`/profile/${firebase.auth().currentUser.uid}`)
								}
							>
								My Profile
							</a> */}
							<a
								onClick={() => {
									firebase.auth().signOut();
								}}
							>
								Sign Out
							</a>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default withRouter(Sidebar);
